import {Ubicacion} from '../ubicacion/ubicacion';
import {Gateway} from '../gateway/gateway';
import {Sensor} from '../sensor/sensor';
import {TipoSensor} from '../tipoSensor/tipoSensor';
import {TipoBateria} from '../tipoBateria/tipoBateria';
import {RegAlarma} from "../regAlarma/regAlarma";
const moment = require('moment');

export class Nodo {
    _id: string;
    etiqueta: string;
    nombre: string;
    fechaAltaBateria: any;
    fechaAlta: any;
    frecuenciaMedicion: Number;
    tiempoActividad: Number;
    estado: boolean;
    sensores_id: Sensor[];
    gateway_id: Gateway;
    ubicacion_id: Ubicacion;
    alarmaActiva: boolean;
    tipo_id: TipoSensor;
    tipoBateria_id: TipoBateria;
    duracionEstimada: Number;
    mantenimiento: boolean;
    color: String;
    regAlarmas: RegAlarma[];
    borradoPermanente: boolean;
    resumen?: string;
    repeatable: boolean;

    static toString(data){
        return `Fecha alta bateria: ${data.fechaAltaBateria ? moment(data.fechaAltaBateria).format('DD-MM-YYYY') : 'N/A'}\n` +
            `Fecha alta: ${data.fechaAlta ? moment(data.fechaAlta).format('DD-MM-YYYY') : 'N/A'} <br/> ` +
            `Sensores: ${data.sensores_id ? data.sensores_id.length : 0}`;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/nodo/nodo.ts